import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/TapCash.png';
import { ResetPassword, Send } from "../constant";
import API from '../services/API';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgetPwd = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email.", { autoClose: 4000 });
      return;
    }

    setLoading(true);
    try {
      const res = await API.post('/schoolStaff/forgotPassword', { email });
      if (res?.data?.response_code === 1000) {
        toast.success("Temporary password sent to your email.", { autoClose: 4000 });
        setTimeout(() => navigate("/"), 2000); // redirect back to login
      } else {
        toast.error(res?.data?.message || "Failed to reset password.", { autoClose: 5000 });
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Network error", { autoClose: 5000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12 p-0">
                <div className="auth-innerright">
                  <div className="reset-password-box">
                    <div className="text-center">
                      <img src={"https://imgur.com/kEzgWVd.png"} alt="logo" height={150} />
                    </div>
                    <div className="card mt-4 mb-0">
                      <h4>{ResetPassword}</h4>
                      <form className="theme-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label className="col-form-label">Email</label>
                          <div className="form-row">
                            <div className="col-md-8">
                              <input
                                className="form-control mb-1"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                              />
                            </div>
                            <div className="col-md-3">
                              <button
                                className="btn btn-primary m-0"
                                type="submit"
                                disabled={loading}
                              >
                                {loading ? "SENDING…" : Send}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                      <ToastContainer theme="colored" position="top-right" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ForgetPwd;
